import { useState, type FormEvent } from 'react';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('website_alt') as string || '').trim();

    if (honeypotValue) {
      setStatus('success');
      setMessage('感谢订阅！请查收确认邮件。');
      setEmail('');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9tvva53pcjqs2fcsjn0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email }).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！请查收确认邮件。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '订阅失败，请稍后重试。';
        if (serverMsg.toLowerCase().includes('spam')) {
          setStatus('success');
          setMessage('感谢订阅！请查收确认邮件。');
        } else {
          setStatus('error');
          setMessage(serverMsg);
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后重试。');
    }
  };

  return (
    <section id="newsletter" className="py-14 bg-secondary-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          订阅我们的资讯
        </h2>
        <p className="text-foreground-600 mb-8">
          每周获取最新的亚洲人成长洞察、深度文章和实用资源，助力您的全面发展之路。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          id="newsletter-form"
          className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
        >
          <div className="form-honeypot">
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="请输入您的邮箱地址"
            required
            className="flex-1 px-5 py-3 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
          />
          <button
            type="submit"
            className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            订阅
          </button>
        </form>

        {status !== 'idle' && (
          <p
            className={`mt-4 text-sm ${
              status === 'success' ? 'text-accent-700' : 'text-foreground-600'
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </section>
  );
}